import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class PlanService {
  cellphoneHostUrl: any = environment.CELLPHONE_BASE_URL;
  bundleHostUrl: any = environment.BUNDLE_BASE_URL;
  insuranceHostUrl: any = environment.INSURANCE_BASE_URL;
  appNodeHostUrl: any = environment.API_BASE_URL;

  /**
   * Integration with micro-services.
   */
  urlToGetCellphonePlans: string = this.cellphoneHostUrl + 'plans/details';
  urlToGetBundlePlans: string = this.bundleHostUrl + 'plans/details';
  urlToGetCellphonePlansByProvider: string = this.cellphoneHostUrl + 'plans/byProviders';
  urlToGetBundlePlansByProvider: string = this.bundleHostUrl + 'plans/byProviders';
  urlToGetCellphonePlansByMultiProvider: string = this.cellphoneHostUrl + 'plans/byMultiProviders';
  urlToGetBundlePlansByMultiProvider: string = this.bundleHostUrl + 'plans/byMultiProviders';
  urlToArchiveCellphonePlan: string = this.cellphoneHostUrl + 'plans/archive';
  urlToArchiveBundlePlan: string = this.bundleHostUrl + 'plans/archive';
  urlToUpvoteCellphonePlan: string = this.cellphoneHostUrl + 'plans/upvoten';
  urlToDownvoteCellphonePlan: string = this.cellphoneHostUrl + 'plans/downvote';
  urlToMapCellphonePlan: string = this.cellphoneHostUrl + 'plans/mapOtherPlanNames';
  urlToUpvoteBundlePlan: string = this.bundleHostUrl + 'plans/upvoten';
  urlToDownvoteBundlePlan: string = this.bundleHostUrl + 'plans/downvote';
  urlToMapPlanBundle: string = this.bundleHostUrl + 'plans/mapOtherPlanNames';

  urlToCreateCellphonePlan: string = this.cellphoneHostUrl + 'cellphone/createPlan';
  urlToUpdateCellphonePlan: string = this.cellphoneHostUrl + 'cellphone/updatePlan';

  urlToCreateBundlePlan: string = this.bundleHostUrl + 'bundles/createPlan';
  urlToUpdateBundlePlan: string = this.bundleHostUrl + 'bundles/updatePlan';

  urlToGetCellphoneApprovalPlans: string = this.cellphoneHostUrl + 'compare/planApprovalList';
  urlToGetBundleApprovalPlans: string = this.bundleHostUrl + 'compare/planApprovalList';
  urlToGetSuggestedCellphonePlans: string = this.cellphoneHostUrl + 'cellphone/getSuggestedPlans';
  urlToGetSuggestedBundlePlans: string = this.bundleHostUrl + 'bundles/getSuggestedPlans';

  constructor(private _http: HttpClient) {}

  getPlans(plan_type, plan_id, task_id): Observable<any> {
    if (plan_id && plan_type) {
      if (plan_type === 'cellphone') {
        return this._http
          .get(this.urlToGetCellphonePlans + '?plan_type=' + plan_type + '&plan_id=' + plan_id)
          .map((res: Response) => res);
      } else if (plan_type === 'bundles') {
        return this._http
          .get(this.urlToGetBundlePlans + '?plan_type=' + plan_type + '&plan_id=' + plan_id)
          .map((res: Response) => res);
      }
    } else if (plan_type) {
      if (plan_type === 'cellphone') {
        return this._http
          .get(this.urlToGetCellphonePlans + '?plan_type=' + plan_type)
          .map((res: Response) => res);
      } else if (plan_type === 'bundles') {
        return this._http
          .get(this.urlToGetBundlePlans + '?plan_type=' + plan_type)
          .map((res: Response) => res);
      }
    } else if (task_id && plan_type) {
      if (plan_type === 'cellphone') {
        return this._http
          .get(this.urlToGetCellphonePlans + '?task_id=' + task_id)
          .map((res: Response) => res);
      } else if (plan_type === 'bundles') {
        return this._http
          .get(this.urlToGetBundlePlans + '?task_id=' + task_id)
          .map((res: Response) => res);
      }
    }
  }

  getPlansByProvider(currentApprovalPlan, planType): Observable<any> {
    if (planType === 'cellphone') {
      if (currentApprovalPlan.selectedProvider && currentApprovalPlan.selectedProvider.length > 0) {
        return this._http
          .get(
            this.urlToGetCellphonePlansByMultiProvider +
              '?provider_id=' +
              currentApprovalPlan.selectedProvider
          )
          .map((res: Response) => res);
      } else if (currentApprovalPlan.providerId) {
        return this._http
          .get(
            this.urlToGetCellphonePlansByMultiProvider +
              '?provider_id=' +
              currentApprovalPlan.providerId
          )
          .map((res: Response) => res);
      }
    } else {
      if (currentApprovalPlan.selectedProvider && currentApprovalPlan.selectedProvider.length > 0) {
        return this._http
          .get(
            this.urlToGetBundlePlansByMultiProvider +
              '?provider_id=' +
              currentApprovalPlan.selectedProvider
          )
          .map((res: Response) => res);
      } else if (currentApprovalPlan.providerId) {
        return this._http
          .get(
            this.urlToGetBundlePlansByMultiProvider +
              '?provider_id=' +
              currentApprovalPlan.providerId
          )
          .map((res: Response) => res);
      }
    }
  }

  archivePlan(plan_type: string, plan_id: string): Observable<any> {
    if (plan_type === 'cellphone') {
      return this._http
        .post(this.urlToArchiveCellphonePlan, { plan_type: plan_type, _id: plan_id })
        .map((res: Response) => res);
    } else if (plan_type === 'bundels') {
      return this._http
        .post(this.urlToArchiveBundlePlan, { plan_type: plan_type, _id: plan_id })
        .map((res: Response) => res);
    }
  }

  upvotePlan(plan_type: string, plan_id: string): Observable<any> {
    if (plan_type === 'cellphone') {
      return this._http
        .post(this.urlToUpvoteCellphonePlan, { plan_type: plan_type, _id: plan_id })
        .map((res: Response) => res);
    } else if (plan_type === 'bundles') {
      return this._http
        .post(this.urlToUpvoteBundlePlan, { plan_type: plan_type, _id: plan_id })
        .map((res: Response) => res);
    }
  }

  downvotePlan(plan_type: string, plan_id: string): Observable<any> {
    if (plan_type === 'cellphone') {
      return this._http
        .post(this.urlToDownvoteCellphonePlan, { plan_type: plan_type, _id: plan_id })
        .map((res: Response) => res);
    } else if (plan_type === 'bundles') {
      return this._http
        .post(this.urlToDownvoteBundlePlan, { plan_type: plan_type, _id: plan_id })
        .map((res: Response) => res);
    }
  }

  createCellphonePlan(data: any): Observable<any> {
    return this._http.post(this.urlToCreateCellphonePlan, data).map((res: Response) => res);
  }

  updateCellphonePlan(data: any): Observable<any> {
    return this._http.post(this.urlToUpdateCellphonePlan, data).map((res: Response) => res);
  }

  createBundlePlan(data: any): Observable<any> {
    return this._http.post(this.urlToCreateBundlePlan, data).map((res: Response) => res);
  }

  updateBundlePlan(data: any): Observable<any> {
    return this._http.post(this.urlToUpdateBundlePlan, data).map((res: Response) => res);
  }

  getApprovalPlanList(data, planType): Observable<any> {
    if (planType === 'cellphone') {
      return this._http.post(this.urlToGetCellphoneApprovalPlans, data).map((res: Response) => res);
    } else {
      return this._http.post(this.urlToGetBundleApprovalPlans, data).map((res: Response) => res);
    }
  }

  getSuggestedCellphonePlans(data): Observable<any> {
    return this._http.post(this.urlToGetSuggestedCellphonePlans, data).map((res: Response) => res);
  }

  getSuggestedBundlePlans(data): Observable<any> {
    return this._http.post(this.urlToGetSuggestedBundlePlans, data).map((res: Response) => res);
  }

  mapOtherPlanName(data): Observable<any> {
    if (data.type === 'cellphone') {
      return this._http.post(this.urlToMapCellphonePlan, data).map((res: Response) => res);
    } else if (data.type === 'bundles') {
      return this._http.post(this.urlToMapPlanBundle, data).map((res: Response) => res);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/main/plan.service.ts